import { createSlice } from "@reduxjs/toolkit";
import { initialState } from "./initialState";
import {
  addApprovalAction,
  addRecruitmentTrackerAction,
  createRecruitmentModuleOpenPositionAction,
  deleteRecruitmentModuleOpenPositionAction,
  deleteRecruitmentTrackerAction,
  getApprovalListAction,
  getRecruitmentModuleOpenPositionAction,
  getRecruitmentTrackerBulkUploadHistoryAction,
  getRecruitmentTrackerListAction,
  getSingleRecruitmentTrackerListAction,
  recruitementTrackerBulkUploadAction,
  updateHiringCheckListDataAction,
  updateRecruitmentModuleOpenPositionAction,
  updateRecruitmentTrackerListAction,
} from "./actions";
import { HrmsType } from "./hrmsTypes";
import { hrmsReducer } from "./reducer";
export const hrmsSlice = createSlice({
  name: "hrms",
  initialState,
  reducers: hrmsReducer,
  extraReducers: {
    [getRecruitmentModuleOpenPositionAction.pending.toString()]: (
      state: HrmsType
    ) => ({
      ...state,
      fetching: true,
    }),
    [getRecruitmentModuleOpenPositionAction.fulfilled.toString()]: (
      state: HrmsType,
      { payload }
    ) => {
      const { success, message, result, status_code, total_count } = payload;

      if (success === 0) {
        return {
          ...state,
          fetching: false,
          success: 0,
          statusCode: status_code,
          error: message,
        };
      }

      return {
        ...state,
        fetching: false,
        statusCode: status_code,
        openPoisitionList: result,
        // success,
        openPositionTotalCount: total_count,
      };
    },
    [getRecruitmentModuleOpenPositionAction.rejected.toString()]: (
      state: HrmsType,
      { error }
    ) => ({
      ...state,
      fetching: false,
      success: 0,
      error: error?.message,
    }),

    [createRecruitmentModuleOpenPositionAction.pending.toString()]: (
      state: HrmsType
    ) => ({
      ...state,
      fetching: true,
    }),
    [createRecruitmentModuleOpenPositionAction.fulfilled.toString()]: (
      state: HrmsType,
      { payload }
    ) => {
      const { success, status_code, message } = payload;
      if (success === 0) {
        return {
          ...state,
          error: message,
          success,
          statusCode: status_code,
        };
      }
      return {
        ...state,
        fetching: false,
        statusCode: status_code,
        success,
        message,
      };
    },

    [createRecruitmentModuleOpenPositionAction.rejected.toString()]: (
      state: HrmsType,
      { error }
    ) => ({
      ...state,
      success: 0,
      error: error?.message,
      fetching: false,
    }),

    [updateRecruitmentModuleOpenPositionAction.pending.toString()]: (
      state: HrmsType
    ) => ({
      ...state,
      fetching: true,
    }),
    [updateRecruitmentModuleOpenPositionAction.fulfilled.toString()]: (
      state: HrmsType,
      { payload }
    ) => {
      const { success, status_code, message } = payload;

      if (success === 0) {
        return {
          ...state,
          error: message,
          success,
          statusCode: status_code,
        };
      }
      return {
        ...state,
        fetching: false,
        statusCode: status_code,
        success,
        message,
      };
    },

    [updateRecruitmentModuleOpenPositionAction.rejected.toString()]: (
      state: HrmsType,
      { error }
    ) => ({
      ...state,
      success: 0,
      error: error?.message,
      fetching: false,
    }),
    //
    [deleteRecruitmentModuleOpenPositionAction.pending.toString()]: (
      state: HrmsType
    ) => ({
      ...state,
      fetching: true,
    }),
    [deleteRecruitmentModuleOpenPositionAction.fulfilled.toString()]: (
      state: HrmsType,
      { payload }
    ) => {
      const { success, status_code, message } = payload;

      if (success === 0) {
        return {
          ...state,
          error: message,
          success,
          statusCode: status_code,
        };
      }
      return {
        ...state,
        fetching: false,
        statusCode: status_code,
        success,
        message,
      };
    },

    [deleteRecruitmentModuleOpenPositionAction.rejected.toString()]: (
      state: HrmsType,
      { error }
    ) => ({
      ...state,
      success: 0,
      error: error?.message,
      fetching: false,
    }),

    [getRecruitmentTrackerListAction.pending.toString()]: (
      state: HrmsType
    ) => ({
      ...state,
      fetching: true,
    }),
    [getRecruitmentTrackerListAction.fulfilled.toString()]: (
      state: HrmsType,
      { payload }
    ) => {
      const { success, message, result, status_code, total_count } = payload;

      if (success === 0) {
        return {
          ...state,
          fetching: false,
          success: 0,
          statusCode: status_code,
          error: message,
        };
      }

      return {
        ...state,
        fetching: false,
        statusCode: status_code,
        recruitmentTrackerList: result?.result,
        // success,
        recruitmentTrackerTotalCount: result?.total_count,
        recruitmentTrackerStageCount: result?.stage_count,
      };
    },
    [getRecruitmentTrackerListAction.rejected.toString()]: (
      state: HrmsType,
      { error }
    ) => ({
      ...state,
      fetching: false,
      success: 0,
      error: error?.message,
    }),

    //
    [addRecruitmentTrackerAction.pending.toString()]: (state: HrmsType) => ({
      ...state,
      addEditFetching: true,
    }),
    [addRecruitmentTrackerAction.fulfilled.toString()]: (
      state: HrmsType,
      { payload }
    ) => {
      const { success, message, status_code } = payload;

      if (success === 0) {
        return {
          ...state,
          addEditFetching: false,
          success,
          error: message,
          statusCode: status_code,
        };
      }

      return {
        ...state,
        addEditFetching: false,
        statusCode: status_code,
        success,
        message,
      };
    },
    [addRecruitmentTrackerAction.rejected.toString()]: (
      state: HrmsType,
      { error }
    ) => ({
      ...state,
      addEditFetching: false,
      success: 0,
      error: error?.message,
    }),
    //
    [updateRecruitmentTrackerListAction.pending.toString()]: (
      state: HrmsType
    ) => ({
      ...state,
      addEditFetching: true,
    }),
    [updateRecruitmentTrackerListAction.fulfilled.toString()]: (
      state: HrmsType,
      { payload }
    ) => {
      const { success, status_code, message } = payload;

      if (success === 0) {
        return {
          ...state,
          error: message,
          success,
          statusCode: status_code,
          addEditFetching: false,
        };
      }
      return {
        ...state,
        addEditFetching: false,
        statusCode: status_code,
        success,
        message,
      };
    },

    [updateRecruitmentTrackerListAction.rejected.toString()]: (
      state: HrmsType,
      { error }
    ) => ({
      ...state,
      success: 0,
      error: error?.message,
      addEditFetching: false,
    }),

    [getSingleRecruitmentTrackerListAction.pending.toString()]: (
      state: HrmsType
    ) => ({
      ...state,
      addEditFetching: true,
    }),
    [getSingleRecruitmentTrackerListAction.fulfilled.toString()]: (
      state: HrmsType,
      { payload }
    ) => {
      const { data } = payload;
      const { success, message, status_code, result } = payload;
      if (success === 0) {
        return {
          ...state,
          addEditFetching: false,
          error: message,
          statusCode: status_code,
          success,
        };
      }
      return {
        ...state,
        addEditFetching: false,
        // success,
        singleRecruitmentTrackerList: result,
      };
    },
    [getSingleRecruitmentTrackerListAction.rejected.toString()]: (
      state: HrmsType,
      { error }
    ) => ({
      ...state,
      addEditFetching: false,
      success: 0,
      error: error.message,
    }),
    [deleteRecruitmentTrackerAction.pending.toString()]: (state: HrmsType) => ({
      ...state,
      fetching: true,
    }),
    [deleteRecruitmentTrackerAction.fulfilled.toString()]: (
      state: HrmsType,
      { payload }
    ) => {
      const { success, status_code, message } = payload;

      if (success === 0) {
        return {
          ...state,
          error: message,
          success,
          statusCode: status_code,
        };
      }
      return {
        ...state,
        fetching: false,
        statusCode: status_code,
        success,
        message,
      };
    },

    [deleteRecruitmentTrackerAction.rejected.toString()]: (
      state: HrmsType,
      { error }
    ) => ({
      ...state,
      success: 0,
      error: error?.message,
      fetching: false,
    }),
    //
    [updateHiringCheckListDataAction.pending.toString()]: (
      state: HrmsType
    ) => ({
      ...state,
      addEditFetching: true,
    }),
    [updateHiringCheckListDataAction.fulfilled.toString()]: (
      state: HrmsType,
      { payload }
    ) => {
      const { success, status_code, message } = payload;

      if (success === 0) {
        return {
          ...state,
          error: message,
          success,
          statusCode: status_code,
        };
      }
      return {
        ...state,
        addEditFetching: false,
        statusCode: status_code,
        success,
        message,
      };
    },

    [updateHiringCheckListDataAction.rejected.toString()]: (
      state: HrmsType,
      { error }
    ) => ({
      ...state,
      success: 0,
      error: error?.message,
      addEditFetching: false,
    }),

    [getApprovalListAction.pending.toString()]: (state: HrmsType) => ({
      ...state,
      fetching: true,
    }),
    [getApprovalListAction.fulfilled.toString()]: (
      state: HrmsType,
      { payload }
    ) => {
      const { success, message, result, status_code, total_count } = payload;

      if (success === 0) {
        return {
          ...state,
          fetching: false,
          success: 0,
          statusCode: status_code,
          error: message,
        };
      }

      return {
        ...state,
        fetching: false,
        statusCode: status_code,
        approvalList: result,
        approvalTotalCount: total_count,
      };
    },
    [getApprovalListAction.rejected.toString()]: (
      state: HrmsType,
      { error }
    ) => ({
      ...state,
      fetching: false,
      success: 0,
      error: error?.message,
    }),

    [addApprovalAction.pending.toString()]: (state: HrmsType) => ({
      ...state,
      addEditFetching: true,
    }),
    [addApprovalAction.fulfilled.toString()]: (
      state: HrmsType,
      { payload }
    ) => {
      const { success, message, result, status_code } = payload;

      if (success === 0) {
        return {
          ...state,
          addEditFetching: false,
          success: 0,
          statusCode: status_code,
          error: message,
        };
      }

      return {
        ...state,
        addEditFetching: false,
        statusCode: status_code,
        message: message,
        success,
      };
    },
    [addApprovalAction.rejected.toString()]: (state: HrmsType, { error }) => ({
      ...state,
      addEditFetching: false,
      success: 0,
      error: error?.message,
    }),

    // Bulk Upload

    [recruitementTrackerBulkUploadAction.pending.toString()]: (
      state: HrmsType
    ) => ({
      ...state,
      fetching: true,
    }),
    [recruitementTrackerBulkUploadAction.fulfilled.toString()]: (
      state: HrmsType,
      { payload }
    ) => {
      const { success, message, data = {}, status_code } = payload;

      if (success === 0) {
        return {
          ...state,
          fetching: false,
          error: message,
          success,
          statusCode: status_code,
        };
      }
      return {
        ...state,
        fetching: false,
        statusCode: status_code,
        hrmsBulkUploadData: payload,
      };
    },

    [recruitementTrackerBulkUploadAction.rejected.toString()]: (
      state: HrmsType,
      { error }
    ) => ({
      ...state,
      fetching: false,
      success: 0,
      error: error?.message,
    }),

    // BULK UPLOAD HISTORY

    [getRecruitmentTrackerBulkUploadHistoryAction.pending.toString()]: (
      state: HrmsType
    ) => ({
      ...state,
      fetching: true,
    }),
    [getRecruitmentTrackerBulkUploadHistoryAction.fulfilled.toString()]: (
      state: HrmsType,
      {payload}
    ) => {
      const {status_code, result, message, success } = payload;
      if(success === 0) {
        return{
          ...state,
          fetching: false,
          success,
          error: message,
          statusCode: status_code,
        };
      }

      return{
        ...state,
        fetching: false,
        statusCode: status_code,
        bulkUploadHistoryData: result?.result,
        bulkUploadHistoryCount: result?.total_count,
      };
    },
    [getRecruitmentTrackerBulkUploadHistoryAction.rejected.toString()]: (
      state: HrmsType,
      {error}
    ) => ({
      ...state,
      success: 0,
      error: error?.message,
      fetching: false,
    }),
  },
});
export const {
  resetHrmsError,
  resetHrmsSuccess,
  resetHrmsFetching,
  resetHrmsMessage,
  resetHrmsStatusCode,
  resetOpenPoisitionList,
  resetOpenPositionTotalCount,
  resetRecruitmentTrackerList,
  resetRecruitmentTrackerTotalCount,
  resetSingleRecruitmentTrackerList,
  resetUniqueCheckFetching,
  resetUniqueCheckMessage,
  resetApprovalList,
  resetRecruitmentTrackerStageCountList,
  resetHrmsBulkUpload,
  resetBulkUploadHistoryCount,
  resetBulkUploadHistoryData,
} = hrmsSlice.actions;
